import { render } from "./TestimonialsSwipers.vue?vue&type=template&id=bc111160&scoped=true"
import script from "./TestimonialsSwipers.vue?vue&type=script&lang=js"
export * from "./TestimonialsSwipers.vue?vue&type=script&lang=js"

import "./TestimonialsSwipers.vue?vue&type=style&index=0&id=bc111160&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-bc111160"

export default script